
import { FileExtended } from "ui/components/FileUpload/FileDropZone/types";
import {
  Tenant,
  TenantCreateFormValues,
  TenantEditFormValues,
  TenantRole,
  TenantRow,
  TenantStorage,
  TenantType,
  TenantUserFormValues,
  TenantUserRow,
} from "./types";
import { FleetDocumentUpload } from "../fleet/vehicles/documents/types";

/*---------------------------------------------------------------------------------------
  TENANT - SEARCH ROW
-----------------------------------------------------------------------------------------*/
export const transformTenantRow = (res: any): TenantRow => ({
  id: res.id,
  tenantType: res.tenantType ?? null,
  name: res.name ?? null,
  companyName: res.companyName ?? null,
  firstName: res.firstName ?? null,
  lastName: res.lastName ?? null,
  email: res.email ?? null,
  personalIdentificationNumber: res.personalIdentificationNumber ?? null,
});

/*---------------------------------------------------------------------------------------
  TENANT - CREATE
-----------------------------------------------------------------------------------------*/
export const transformTenantCreate = (formValues: TenantCreateFormValues): any => ({
  tenantTypeId: formValues.tenantTypeId,
  companyName: formValues.companyName,
  firstName: formValues.firstName,
  lastName: formValues.lastName,
  address: formValues.address,
  phoneNumber: formValues.phoneNumber,
  mobilePhoneNumber: formValues.mobilePhoneNumber,
  email: formValues.email,
  web: formValues.web,
  personalIdentificationNumber: formValues.personalIdentificationNumber,
  timezone: formValues.timezone,
  logoUploadId: formValues.logo?.[0]?.id ?? null,
});

/*---------------------------------------------------------------------------------------
  TENANT - USER
-----------------------------------------------------------------------------------------*/
export const transformTenantUserRow = (res: any): TenantUserRow => ({
  id: res.id,
  firstName: res.firstName ?? null,
  lastName: res.lastName ?? null,
  email: res.email ?? null,
  roles: res.roles ?? [],
});

export const transformTenantUserCreate = (formValues: TenantUserFormValues): any => ({
  firstName: formValues.firstName,
  lastName: formValues.lastName,
  email: formValues.email,
  username: formValues.email,
  password: formValues.password,
  roles: formValues.roleId ? [formValues.roleId] : [],
});

export const transformTenantRole = (res: any): TenantRole => ({
  id: res.id,
  name: res.name,
  isAdmin: res.isAdmin,
  isSystem: res.isSystem,
});



export const transformTenant = (res: any): Tenant => {
  return {
    id: res.id,
    tenantType: res.tenantType,
    companyName: res.companyName,
    firstName: res.firstName,
    lastName: res.lastName,
    headquartersAddress: res.headquartersAddress,
    address: res.address ?? null,
    phoneNumber: res.phoneNumber,
    mobilePhoneNumber: res.mobilePhoneNumber,
    email: res.email,
    web: res.web,
    personalIdentificationNumber: res.personalIdentificationNumber,
    transactionAccountNumber: res.transactionAccountNumber,
    timezone: res.timezone,
    logoUpload: res.logoUpload,
    bankAccounts: res.bankAccounts ?? [],
  };
};

export const transformTenantEditFormValues = async (
  res: Tenant
): Promise<TenantEditFormValues> => {
  const files: FileExtended[] = [];

  if (res.logoUpload?.url) {
    const dummyBlob = new Blob([""], { type: res.logoUpload.contentType });

    const fakeFile: FileExtended = Object.assign(
      new File([dummyBlob], res.logoUpload.originalFileName, {
        type: res.logoUpload.contentType,
        lastModified: new Date(res.logoUpload.created).getTime(),
      }),
      {
        id: res.logoUpload.id,
        url: res.logoUpload.url,
        isNew: false,
      }
    );
    files.push(fakeFile);
  }

  return {
    id: res.id,
    tenantTypeId: res.tenantType.id,
    companyName: res.companyName,
    firstName: res.firstName,
    lastName: res.lastName,
    headquartersAddress: res.headquartersAddress,
    address: res.address ?? null,
    phoneNumber: res.phoneNumber,
    mobilePhoneNumber: res.mobilePhoneNumber,
    email: res.email,
    web: res.web,
    personalIdentificationNumber: res.personalIdentificationNumber,
    transactionAccountNumber: res.transactionAccountNumber,
    timezone: res.timezone,
    logo: files,
  };
};



// export const transformTenantCreate = (tenant: TenantEditFormValues): any => {
//   return {
//     tenantType: tenant.tenantType,
//     companyName: tenant.companyName,
//     firstName: tenant.firstName,
//     lastName: tenant.lastName,
//     headquartersAddress: tenant.headquartersAddress,
//     phoneNumber: tenant.phoneNumber,
//     mobilePhoneNumber: tenant.mobilePhoneNumber,
//     personalIdentificationNumber: tenant.personalIdentificationNumber,
//     transactionAccountNumber: tenant.transactionAccountNumber,
//     timezone: tenant.timezone,
//     logo: tenant.logo,
//   };
// };

export const transformTenantUpdate = (tenant: TenantEditFormValues, logoUploads: FleetDocumentUpload[]): any => {
  return {
    id: tenant.id,
    tenantTypeId: tenant.tenantTypeId,
    companyName: tenant.companyName,
    firstName: tenant.firstName,
    lastName: tenant.lastName,
    address: tenant.address,
    phoneNumber: tenant.phoneNumber,
    mobilePhoneNumber: tenant.mobilePhoneNumber,
    email: tenant.email,
    web: tenant.web,
    personalIdentificationNumber: tenant.personalIdentificationNumber,
    transactionAccountNumber: tenant.transactionAccountNumber,
    timezone: tenant.timezone,
    logoUploadId: logoUploads?.[0]?.id ?? tenant.logo?.[0]?.id ?? null,
  };
};


export const transformTenantType = (res: any): TenantType => {
  return {
    id: res.id,
    name: res.name,
  };
};


export const transformTenantStorage = (res: any): TenantStorage => ({
  tenantId: res.tenantId,
  activeKb: res.activeKb ?? 0,
  activeFiles: res.activeFiles ?? 0,
  totalKb: res.totalKb ?? 0,
  totalFiles: res.totalFiles ?? 0,
});
